import ReservationForm from "./form/ReservationForm";
import { FC, useEffect, useState } from "react";
import { reservationForm } from "@/utils/objects";
import {
  mergeDateAndTime,
  seperateDateAndTime,
  submitEditForm,
} from "@/utils/formChange";
import { useRefresh } from "react-admin";
import axiosInstance from "@/utils/axiosInstance";
import { singleProp } from "@/interface/dataInterface";
import { Reservation } from "@/interface/entityInterface";

const ReservationEdit: FC<singleProp> = ({ prop }) => {
  const refresh = useRefresh();
  const [formProp, setFormProp] = useState(reservationForm);
  const [selected, setSelected] = useState<any[]>([]);
  const {
    name,
    phone,
    email,
    make,
    model,
    vin,
    license_plate,
    year,
    date,
    time,
    notes,
    reservation_items,
    technician_id,
  } = formProp;

  useEffect(() => {
    const reservationItems: any[] = [];
    selected.map((item) =>
      reservationItems.push({
        inventory_id: item.id,
        quantity: item.quantity || 1,
        price: item.price,
      }),
    );

    setFormProp((prev: any) => {
      return {
        ...prev,
        reservation_items: reservationItems,
      };
    });
  }, [selected]);

  useEffect(() => {
    const unsub = async () => {
      if (!prop) return;
      try {
        const { data } = await axiosInstance.get<Reservation>(
          `/auto-service-reservation/${prop}`,
        );

        const {
          branch_id,
          date,
          technician_id,
          status,
          notes,
          guest_user,
          guest_vehicle,
        } = data;

        const { name, email, phone } = guest_user;
        const { make, model, vin, license_plate, year } = guest_vehicle;

        setFormProp({
          name,
          email,
          phone,
          make,
          model,
          vin,
          license_plate,
          year: year as any,
          branch_id,
          technician_id,
          date: seperateDateAndTime(date).datePart,
          time: seperateDateAndTime(date).timePart,
          status,
          notes,
          reservation_items: [],
        });
      } catch (err) {
        console.log(err);
      }
    };

    unsub();
  }, [prop]);

  return (
    <ReservationForm
      mode="edit"
      formProp={formProp}
      setFormProp={setFormProp}
      otherData={selected}
      setOtherData={setSelected}
      submitForm={() =>
        submitEditForm(
          prop,
          "auto-service-reservation",
          {
            client: { name, email, phone },
            vehicle: { make, model, year, vin, license_plate },
            date: mergeDateAndTime(date, time),
            technician_id: +formProp.technician_id,
            branch_id: +formProp.branch_id,
            notes,
            status: "PENDING",
            reservation_items,
          },
          refresh,
        )
      }
    />
  );
};

export default ReservationEdit;
